import type { SocialCaptions } from 'bundles/sharing-common/types/sharingSharedTypes';

import _t from 'i18n!nls/shared-articles';

// Placeholder
// TODO: Replace text with official share caption copy

export default ({ articleTitle }: $TSFixMe): SocialCaptions => {
  return {
    twitter: () => _t('Check out this article I read on Coursera! #{articleTitle}', { articleTitle }),
    whatsapp: (shareLink) =>
      _t('Check out this article I read on Coursera! #{articleTitle} #{shareLink}', { articleTitle, shareLink }),
    emailSubject: () => _t('Check out this article I read on Coursera! #{articleTitle}', { articleTitle }),
    emailBody: (shareLink) =>
      _t('Check out this article I read on Coursera! #{articleTitle} #{shareLink}', { articleTitle, shareLink }),
  };
};
